import React, { FC, FormEvent, useEffect, useState } from "react";
import { GaveDto, GaveRowDto, IGaverBidrag } from "./gbmTypes";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import Table, { ColumnDefinitionType } from "../table/Table";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import { useHistory } from "react-router-dom";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";
import { isBlank } from "../kos/Kos";
import {
  formatStringToNumber,
  IntlNubmerFormatter,
  removeWhiteSpaces,
} from "../../utility/formatInputField";
import LoadingSpinnerComponent from "../customhtmlcomponents/LoadingSpinnerComponent";
import Input from "../customhtmlcomponents/Input";

const GaverBidrag: FC<IGaverBidrag> = ({
  currentForeningReportNumber,
  username,
  message,
  setModal,
}) => {
  const [gaveDto, setGaveDto] = useState<GaveDto>({
    foreningsNummer: currentForeningReportNumber.toString(),
    rows: [
      {
        id: 0,
        beskrivelse: "",
        alternativ: "",
        belop: "",
      } as GaveRowDto,
    ],
    totalBelop: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Gaver og Bidrag ble lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 3000);
  };
  const filterOutEmptyRows = () => {
    const rows = gaveDto.rows.slice().filter((k) => !isBlank(k.beskrivelse));
    console.log(rows);
    return rows;
  };
  const createFilteredDto = () => {
    const rows = filterOutEmptyRows();

    const removeWhiteSpacesFromRows = rows.map((row) => ({
      ...row,
      belop:
        row.belop === ""
          ? (row.belop = 0)
          : removeWhiteSpaces(row.belop.toString()),
    }));
    console.log(removeWhiteSpacesFromRows);

    const filteredDto = {
      ...gaveDto,
      rows: removeWhiteSpacesFromRows,
      totalBelop: removeWhiteSpaces(gaveDto.totalBelop.toString()),
    };
    return filteredDto;
  };
  const saveOnClick =async (e: React.BaseSyntheticEvent, link: string) => {
    postFormData(false)
  };

  const postFormData = async (redirectToNextPage: boolean) => {
    const filteredDto = createFilteredDto();
    console.log("gavedto", gaveDto);
    setIsSubmitting(true)

    axios
      .post<GaveDto>(URLS.GAVER_BIDRAG_POST, filteredDto, {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
        },
      })
      .then((response) => {
        message({
          body: {
            body: {
              message: `Gaver og Bidrag ble lagret.`,
            },
          },
        });
        setModal(true);
        setTimeout(() => setModal(false), 1750);
        if(redirectToNextPage){
          setTimeout(
            () => {
              setIsSubmitting(false)
              history.push({
              pathname: "/regnskapstabell",
              state: currentForeningReportNumber,
              })
            },
            1750
          );
        }
        

        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av 'Gaver og økonomiske bidrag'. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false)
          setIsSubmitting(false)
        }, 5000);
      });
  }

  const history = useHistory();
  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    postFormData(true);
  };

  const addRow = () => {
    const newID = new Date().getMilliseconds().valueOf();
    const newRow: GaveRowDto = {
      id: newID,
      beskrivelse: "",
      alternativ: "",
      belop: "",
    };
    setGaveDto((prevState) => ({
      ...prevState,
      rows: [...prevState.rows, newRow],
    }));
  };

  const handleChange = (e: any, row: any) => {
    let { name, value } = e.target;
    console.log(value, "before", name);
    console.log(value, "after");
    const { id } = row;
    const newItem = { ...row, [name]: value };
    console.log(newItem);
    const oldItems = gaveDto.rows.slice();
    const index = oldItems.indexOf(row);
    const filteredItems = oldItems.filter((item: any) => item.id !== id);

    filteredItems.splice(index, 0, newItem);
    const toal = sum(filteredItems);
    console.log("inside handle change", toal);
    // @ts-ignore
    setGaveDto((prevState) => ({
      ...prevState,
      rows: filteredItems,
      totalBelop: sum(filteredItems),
    }));
  };

  const isRowEmpty = (rest: Pick<GaveRowDto, "beskrivelse" | "alternativ">) => {
    const isEmpty = Object.values(rest as any).every(
      (x) => x === null || x === ""
    );
    return isEmpty;
  };

  const filterRows = (rows: GaveRowDto[]) => {
    //@ts-ignore
    const { id, belop, ...rest }: GaveRowDto = rows.slice().pop();
    return rest;
  };

  const appendEmpty = (response: AxiosResponse<GaveDto>) => {
    const { rows, totalBelop, ...rest } = response.data;
    const formattedRows = rows.map((row) => ({
      ...row,
      belop: IntlNubmerFormatter(row.belop as number),
    }));
    const total = IntlNubmerFormatter(totalBelop as number);
    const gaverState = {
      ...rest,
      rows: formattedRows,
      totalBelop: total,
    };
    setGaveDto(gaverState);
    const gaveRowDtos = formattedRows.slice();
    if (gaveRowDtos.length === 0) {
      addRow();
    } else {
      const filteredRows = filterRows(gaveRowDtos);
      const isEmpty = isRowEmpty(filteredRows);
      if (!isEmpty) {
        addRow();
      }
    }
  };
  useEffect(() => {
    async function getGaver() {
      setIsLoading(true);
      await axios
        .get(`${URLS.GAVER_BIDRAG_GET}${gaveDto.foreningsNummer}`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
        .then(async (response: AxiosResponse<GaveDto>) => {
          console.log(response.data);
          appendEmpty(response);
        })
        .catch((error) => console.log(error));
      setTimeout(() => setIsLoading(false), 500);
    }

    getGaver();
  }, [setIsLoading]);

  const removeRow = (id: number) => {
    let toRemove = gaveDto.rows;
    const minliste = toRemove.filter((item) => item.id !== id);
    setGaveDto((prevState) => ({
      ...prevState,
      rows: minliste,
      totalBelop: sum(minliste),
    }));
  };
  const sum = (rows: GaveRowDto[]) => {
    const total = rows.reduce((acc, curr) => {
      return acc + formatStringToNumber(curr.belop as string);
    }, 0);
    return IntlNubmerFormatter(total);
  };

  // @ts-ignore
  const columns: ColumnDefinitionType<GaveRowDto, keyof GaveRowDto>[] = [
    {
      key: "beskrivelse",
      inputType: "text",
      header: "Beskrivelse",
      width: 300,
      colSpan: 2,
    },
    {
      key: "alternativ",
      inputType: "text",
      header: "Hvem er mottaker",
      width: 300,
    },
    {
      key: "belop",
      inputType: "text",
      header: "Beløp",
      textStyle: "flex flex-grow text-right pr-2 md:w-4/5",
      isNumberField: true,
    },
  ];

  const isAdmin = username === "1";

  return (
    <>
      <NavigationBar saveOnClick={saveOnClick} />
      {isLoading ? (
        <LoadingSpinnerComponent />
      ) : (
        <form onSubmit={submit}>
          <div className="bg-sk-tertiary-red">
            <div>
              <p className="text-black text-center text-2xl font-bold mt-2py-2 p">
                6. Gaver og økonomiske bidrag
              </p>
            </div>

            {/*Main wrapper*/}
            <div className="flex flex-row m-auto w-full justify-center">
              <div className="mt-4 h-2/3 w-full self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl transform scale-100 md:scale-75">
                <div>
                  <p className="text-black text-center text-2xl font-bold mt-4 py-2">
                    6.1 Gaver og økonomiske bidrag
                  </p>
                </div>

                <Table
                  handleChange={handleChange}
                  addRow={addRow}
                  removeRow={removeRow}
                  data={gaveDto.rows as GaveRowDto[]}
                  columns={columns}
                  footer={{
                    enabled: true,
                    footerData: gaveDto.totalBelop,
                  }}
                  isAdmin={isAdmin}
                >
                  <tfoot className="border-t border-sk-tertiary-blue">
                    <tr className="p-5 border-sk-tertiary-blue">
                      <td colSpan={2}>
                        <p className="font-thin text-2xl"> TOTAL </p>
                      </td>
                      <td></td>
                      <td className="flex justify-end border-sk-tertiary-blue p-5">
                        <Input
                          flex={true}
                          labelopts={{
                            labelOn: false,
                            defaultLabelStyle: false,
                          }}
                          className="flex flex-grow text-right pr-2 md: w-3/5"
                          placeholder="Total Beløp..."
                          name="totalbelop"
                          type="text"
                          label="Beskrivelse"
                          id="totalbelop"
                          disabled
                          value={gaveDto.totalBelop}
                        />
                        <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                          <span className="flex items-center px-2">NOK</span>
                        </span>
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </div>
            {/*This is the buttons at the bottom of the page, FORRIGE and LAGRE OG GÅ VIDERE*/}
            <FooterButtons previousLocation="/kos" saveOnClick={saveOnClick} isSubmitting={isSubmitting} />
          </div>
        </form>
      )}
    </>
  );
};

export default GaverBidrag;
